<template>
  <div class="businessApplicationDetails">
    <div class="businessApplicationDetails-first">
      <div class="businessApplicationDetails-word">基本信息</div>
      <div :v-model="businessApplicationVO" class="businessApplicationDetail-message">
        <table class="businessApplicationTable" style="width: 100%">
          <tr>
            <td class="tableLabel">商务编号:</td>
            <td>{{businessApplicationVO.businessApplicationNO}}</td>
            <td class="tableLabel">状态:</td>
            <td style="width: 220px">
              {{businessApplicationVO.itemName}}
            </td>
            <td class="tableLabel">制单时间:</td>
            <td style="width: 220px">{{businessApplicationVO.createdDate}}</td>
          </tr>
          <tr>
            <td class="tableLabel">此次销售量:</td>
            <td>{{businessApplicationVO.salesQuantity}}</td>
            <td class="tableLabel">年销售总量:</td>
            <td>{{businessApplicationVO.yearSalesQuantity}}</td>
            <td class="tableLabel">有效期限:</td>
            <td>
              <div v-if="businessApplicationVO.timeLimit === 0">
                {{businessApplicationVO.beginDate.substring(0, 10)}}
                至
                {{businessApplicationVO.endDate.substring(0, 10)}}
              </div>
              <div v-if="businessApplicationVO.timeLimit === 1">永久有效</div>
              <div v-if="businessApplicationVO.timeLimit === 2">一次有效</div>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">客户名称:</td>
            <td>{{businessApplicationVO.customerName}}</td>
            <td class="tableLabel">联系人:</td>
            <td>{{businessApplicationVO.employeeName}}</td>
            <td class="tableLabel">欠款金额:</td>
            <td>{{businessApplicationVO.packDeliveryFee}}</td>
          </tr>
          <tr>
            <td class="tableLabel">免包装和运输费用:</td>
            <td>{{businessApplicationVO.containsFee ? "是" : "否"}}</td>
            <td class="tableLabel">包装费:</td>
            <td>{{businessApplicationVO.packDeliveryFee}}</td>
            <td class="tableLabel">付款方式:</td>
            <td colspan="3">{{businessApplicationVO.payMethod}}</td>
          </tr>
          <tr>
            <td class="tableLabel">商务理由:</td>
            <td colspan="5">{{businessApplicationVO.reason}}</td>
          </tr>
          <tr>
            <td class="tableLabel">备注:</td>
            <td colspan="5">{{businessApplicationVO.note}}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="businessApplicationDetails-seond">
      <div class="businessApplicationDetails-seond-top">
        <div style="position: absolute; top: 0; left: 0; z-index: 99; width: 100%">
          <div class="businessApplicationDetails-word">价格申请</div>
        </div>
        <table cellspacing="0" class="table-pj">
          <tr>
            <td>汇总统计</td>
            <td>平均申请价毛利率</td>
            <td v-if="costLookAuth" style="color: rgb(45, 140, 240)">{{businessApplicationVO.applicationAvgPercent}}%</td>
            <td v-else>***</td>
            <td>平均审核价毛利率</td>
            <td>
              <div>
                营销中心：
                <span v-if="costLookAuth" style="color: rgb(45, 140, 240)">{{businessApplicationVO.approve1AvgPercent}}%</span>
                <span v-else>***</span>
              </div>
              <div>
                总监：
                <span v-if="costLookAuth" style="color: rgb(45, 140, 240)">{{businessApplicationVO.approve2AvgPercent}}%</span>
                <span v-else>***</span>
              </div>
              <div>
                财务总监：
                <span v-if="costLookAuth" style="color: rgb(45, 140, 240)">{{businessApplicationVO.finApproveAvgPercent}}%</span>
                <span v-else>***</span>
              </div>
              <div>
                总经理：
                <span v-if="costLookAuth" style="color: rgb(45, 140, 240)">{{businessApplicationVO.approve3AvgPercent}}%</span>
                <span v-else>***</span>
              </div>
            </td>
          </tr>
        </table>
        <el-table :data="businessApplicationVO.applicationPriceWrapperS" default-expand-all class="jg-el-table" style="width: 100%; margin-top: 80px">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-table :data="props.row.paDetailVOS" style="width: 90%; margin: 0 auto">
                  <el-table-column prop="nameValues" label="特性">
                    <template slot-scope="scope">
                      <span v-if="scope.row.priceApplicationType ===20 && scope.row.applicationType === 10">{{scope.row.param1}}</span>
                      <span v-if="scope.row.priceApplicationType ===20 && scope.row.applicationType === 20">{{scope.row.nameValues}}</span>
                      <div v-else>
                        <span v-if="businessApplicationVO.costVisible === true" style="color: #2d8cf0; cursor: pointer" @click="$refs.preview.open(scope.row)">
                          {{scope.row.nameValues}}
                        </span>
                        <span v-else>{{scope.row.nameValues}}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="申请类型" prop="executePrice">
                    <template slot-scope="scope">
                      <div v-if="scope.row.applicationType === 10">按产品申请</div>
                      <div v-if="scope.row.applicationType === 20">按规格申请</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="执行价" prop="executePrice">
                    <template slot-scope="scope">
                      <div v-if="scope.row.priceApplicationType === 20">申请折扣</div>
                      <div v-else>
                        <div v-if="businessApplicationVO.approveStatus === 10">
                          <div v-if="scope.row.standardFloatingPrice === 0">
                            <div v-if="businessApplicationVO.costVisible === true">
                              成本价:
                              <el-input
                                  v-model="scope.row.costPrice"
                                  align="center"
                                  type="number"
                                  style="width: 80px"
                                  min="0"
                                  @change="getMeanData(scope.row)"/>
                            </div>
                            <div :style="businessApplicationVO.applicantPositon === 1 ? 'font-weight: 500' : 'font-weight: bold'">销售员:{{scope.row.level1Price}}</div>
                            <div v-if="props.row.userPosition !== 1">区总:{{scope.row.level2Price}}</div>
                            <div v-if="props.row.userPosition !== 1 && props.row.userPosition !== 2">总监:{{scope.row.level3Price}}</div>
                          </div>
                          <div v-else>
                            <div v-if="businessApplicationVO.costVisible === true">
                              成本价:
                              <el-input
                                  v-model="scope.row.costPrice"
                                  align="center"
                                  type="number"
                                  style="width: 80px"
                                  min="0"
                                  @change="getMeanData(scope.row)"/>
                              <el-input
                                  v-model="scope.row.costFloatingPrice"
                                  align="center"
                                  type="number"
                                  style="width: 80px"
                                  min="0"
                                  @change="getMeanData(scope.row)"/>
                            </div>
                            <div :style="businessApplicationVO.applicantPositon === 1 ? 'font-weight: 500' : 'font-weight: bold'">销售员:{{scope.row.level1Price + "/" + scope.row.level1FloatingPrice}}</div>
                            <div v-if="props.row.userPosition !== 1">区总:{{scope.row.level2Price + "/" + scope.row.level2FloatingPrice}}</div>
                            <div v-if="props.row.userPosition !== 1 && props.row.userPosition !== 2">总监:{{scope.row.level3Price + "/" + scope.row.level3FloatingPrice}}</div>
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="scope.row.standardFloatingPrice === 0">
                            <div v-if="businessApplicationVO.costVisible === true">成本价:{{scope.row.costPrice}}</div>
                            <div :style="businessApplicationVO.applicantPositon === 1 ? 'font-weight: 500' : 'font-weight: bold'">销售员:{{scope.row.level1Price}}</div>
                            <div v-if="props.row.userPosition !== 1">区总:{{scope.row.level2Price}}</div>
                            <div v-if="props.row.userPosition !== 1 && props.row.userPosition !== 2">总监:{{scope.row.level3Price}}</div>
                          </div>
                          <div v-else>
                            <div v-if="businessApplicationVO.costVisible === true">
                              {{"成本价:" + scope.row.costPrice + "/" + scope.row.costFloatingPrice}}
                            </div>
                            <div :style="businessApplicationVO.applicantPositon === 1 ? 'font-weight: 500' : 'font-weight: bold'">销售员:{{scope.row.level1Price + "/" + scope.row.level1FloatingPrice}}</div>
                            <div v-if="props.row.userPosition !== 1">
                              {{"区总:" + scope.row.level2Price + "/" + scope.row.level2FloatingPrice}}
                            </div>
                            <div v-if="props.row.userPosition !== 1 && props.row.userPosition !== 2">
                              {{"总监:" + scope.row.level3Price + "/" + scope.row.level3FloatingPrice}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="申请价格" prop="applicationPrice">
                    <template slot-scope="scope">
                      <div v-if="scope.row.priceApplicationType === 20">
                        <div v-if="scope.row.floatingPriceType === 20">
                          <div>线缆单价折扣:{{scope.row.price}}%</div>
                          <div>每层加工费:{{scope.row.floatingPrice}}</div>
                        </div>
                        <div v-else>
                          <div>线缆单价折扣:{{scope.row.price}}%</div>
                          <div>加工费折扣:{{scope.row.floatingPrice}}%</div>
                        </div>
                      </div>
                      <div v-else>
                        <div v-if="scope.row.floatingPrice === 0">
                          {{scope.row.price}}
                          <div v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                            <div>
                              毛利：
                              <span>
                                {{parseFloat((scope.row.price - scope.row.costPrice) / 1.13).toFixed(2)}}
                              </span>
                            </div>
                            <div>
                              毛利率：
                              <span v-if="scope.row.price === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.price - scope.row.costPrice) / scope.row.price) * 100).toFixed(2)}}
                              </span>
                              %
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          {{scope.row.price + "/" + scope.row.floatingPrice}}
                          <div v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                            <div>
                              毛利：
                              <span>
                                {{parseFloat((scope.row.price - scope.row.costPrice) / 1.13).toFixed(2)}}
                              </span>
                            </div>
                            <div>
                              毛利率：
                              <span v-if="scope.row.price === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.price - scope.row.costPrice) / scope.row.price) * 100).toFixed(2)}}
                              </span>
                              %
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column width="380" label="审核价格" prop="mainRepairMan">
                    <template slot-scope="scope">
                      <!--1-->
                      <div>
                        <div v-if="businessApplicationVO.approveStatus === 1">
                          <div v-if="scope.row.priceApplicationType === 20" style="display: flex; flex-direction: row; justify-content: space-between">
                            <div>
                              营销中心:线缆:
                              <el-input
                                  v-model="scope.row.approve1Price"
                                  align="center"
                                  type="number"
                                  min="0"
                                  style="width: 80px"
                                  @change="isChangeFunction(scope.row)"/>%
                            </div>
                            <div v-if="scope.row.floatingPriceType === 20" style="width: 46%; text-align: left">
                              每层加工费:
                              <el-input
                                  v-model="scope.row.approve1FloatingPrice"
                                  align="center"
                                  type="number"
                                  min="0"
                                  style="width: 80px"
                                  @change="isChangeFunction(scope.row)"/>
                            </div>
                            <div v-else style="width: 46%; text-align: left">
                              加工费折扣:
                              <el-input
                                  v-model="scope.row.approve1FloatingPrice"
                                  align="center"
                                  type="number"
                                  min="0"
                                  style="width: 80px"
                                  @change="isChangeFunction(scope.row)"/>%
                            </div>
                          </div>
                          <div v-else>
                            <div v-if="scope.row.floatingPrice === 0">
                              营销中心:
                              <el-input
                                  v-model="scope.row.approve1Price"
                                  align="center"
                                  type="number"
                                  min="0"
                                  style="width: 80px"
                                  @change="getMeanData(scope.row)"/>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span v-if="scope.row.approve1Price === 0">0</span>
                                <span v-else> {{parseFloat((scope.row.approve1Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.approve1Price === 0">0</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.approve1Price - scope.row.costPrice) / scope.row.approve1Price) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                            <div v-else>
                              营销中心:
                              <el-input
                                  v-model="scope.row.approve1Price"
                                  align="center"
                                  type="number"
                                  min="0"
                                  style="width: 80px"
                                  @change="getMeanData(scope.row)"/>
                              <el-input
                                  v-model="scope.row.approve1FloatingPrice"
                                  align="center"
                                  type="number"
                                  min="0"
                                  style="width: 80px"
                                  @change="getMeanData(scope.row)"/>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span v-if="scope.row.approve1Price === 0">0</span>
                                <span v-else> {{parseFloat((scope.row.approve1Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.approve1Price === 0">0</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.approve1Price - scope.row.costPrice) / scope.row.approve1Price) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="scope.row.priceApplicationType === 20" style="display: flex; flex-direction: row; justify-content: space-between">
                            <div v-if="scope.row.price === scope.row.approve1Price">
                              营销中心:线缆: <span>{{scope.row.approve1Price}}%</span>
                            </div>
                            <div v-else>
                              营销中心:线缆: <span style="color: red">{{scope.row.approve1Price}}%</span>
                            </div>
                            <div v-if="scope.row.floatingPrice === scope.row.approve1FloatingPrice" style="width: 46%; text-align: left">
                              <div v-if="scope.row.floatingPriceType === 20">
                                每层加工费: <span>{{scope.row.approve1FloatingPrice}}</span>
                              </div>
                              <div v-else>
                                加工费折扣: <span>{{scope.row.approve1FloatingPrice}}%</span>
                              </div>
                            </div>
                            <div v-else style="width: 46%; text-align: left">
                              <div v-if="scope.row.floatingPriceType === 20">
                                每层加工费: <span style="color: red">{{scope.row.approve1FloatingPrice}}</span>
                              </div>
                              <div v-else>
                                加工费折扣: <span style="color: red">{{scope.row.approve1FloatingPrice}}%</span>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <div v-if="scope.row.floatingPrice === 0">
                              <div v-if="scope.row.price === scope.row.approve1Price">
                                营销中心:
                                <span>{{scope.row.approve1Price}}</span>
                                <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                  /毛利：
                                  <span v-if="scope.row.approve1Price === 0">0</span>
                                  <span v-else> {{parseFloat((scope.row.approve1Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                  毛利率：
                                  <span v-if="scope.row.approve1Price === 0">0</span>
                                  <span v-else>
                                    {{parseFloat(((scope.row.approve1Price - scope.row.costPrice) / scope.row.approve1Price) * 100).toFixed(2)}}
                                  </span>
                                  %
                                </span>
                              </div>
                              <div v-else>
                                营销中心:
                                <span style="color: red">{{scope.row.approve1Price}}</span>
                                <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                  /毛利：
                                  <span v-if="scope.row.approve1Price === 0">0</span>
                                  <span v-else> {{parseFloat((scope.row.approve1Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                  毛利率：
                                  <span v-if="scope.row.approve1Price === 0">0</span>
                                  <span v-else>
                                    {{parseFloat(((scope.row.approve1Price - scope.row.costPrice) / scope.row.approve1Price) * 100).toFixed(2)}}
                                  </span>
                                  %
                                </span>
                              </div>
                            </div>
                            <div v-else>
                              <div v-if="scope.row.price === scope.row.approve1Price">
                                营销中心<span>
                                  {{scope.row.approve1Price + "/" + scope.row.approve1FloatingPrice}}
                                </span>
                                <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                  /毛利：
                                  <span v-if="scope.row.approve1Price === 0">0</span>
                                  <span v-else> {{parseFloat((scope.row.approve1Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                  毛利率：
                                  <span v-if="scope.row.approve1Price === 0">0</span>
                                  <span v-else>
                                    {{parseFloat(((scope.row.approve1Price - scope.row.costPrice) / scope.row.approve1Price) * 100).toFixed(2)}}
                                  </span>
                                  %
                                </span>
                              </div>
                              <div v-else>
                                营销中心<span style="color: red">
                                  {{scope.row.approve1Price + "/" + scope.row.approve1FloatingPrice}}
                                </span>
                                <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                  /毛利：
                                  <span v-if="scope.row.approve1Price === 0">0</span>
                                  <span v-else> {{parseFloat((scope.row.approve1Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                  毛利率：
                                  <span v-if="scope.row.approve1Price === 0">0</span>
                                  <span v-else>
                                    {{parseFloat(((scope.row.approve1Price - scope.row.costPrice) / scope.row.approve1Price) * 100).toFixed(2)}}
                                  </span>
                                  %
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!--2-->
                      <div>
                        <div v-if="businessApplicationVO.approveStatus === 2">
                          <div v-if="scope.row.priceApplicationType === 20" style="display: flex; flex-direction: row; justify-content: space-between">
                            <div>
                              总监:线缆:
                              <el-input
                                  v-model="scope.row.approve2Price"
                                  align="center"
                                  type="number"
                                  style="width: 80px"
                                  min="0"
                                  @change="isChangeFunction(scope.row)"/>%
                            </div>
                            <div v-if="scope.row.floatingPriceType === 20" style="width: 46%; text-align: left">
                              每层加工费:
                              <el-input
                                  v-model="scope.row.approve2FloatingPrice"
                                  align="center"
                                  type="number"
                                  style="width: 80px"
                                  min="0"
                                  @change="isChangeFunction(scope.row)"/>
                            </div>
                            <div v-else style="width: 46%; text-align: left">
                              加工费折扣:
                              <el-input
                                  v-model="scope.row.approve2FloatingPrice"
                                  align="center"
                                  type="number"
                                  style="width: 80px"
                                  min="0"
                                  @change="isChangeFunction(scope.row)"/>%
                            </div>
                          </div>
                          <div v-else>
                            <div v-if="scope.row.floatingPrice === 0">
                              总监:
                              <el-input
                                  v-model="scope.row.approve2Price"
                                  align="center"
                                  type="number"
                                  style="width: 80px"
                                  min="0"
                                  @change="getMeanData(scope.row)"/>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span v-if="scope.row.approve2Price === 0">0</span>
                                <span v-else> {{parseFloat((scope.row.approve2Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.approve2Price === 0">0</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.approve2Price - scope.row.costPrice) / scope.row.approve2Price) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                            <div v-else>
                              总监:
                              <el-input
                                  v-model="scope.row.approve2Price"
                                  align="center"
                                  type="number"
                                  style="width: 80px"
                                  min="0"
                                  @change="getMeanData(scope.row)"/>
                              <el-input
                                  v-model="scope.row.approve2FloatingPrice"
                                  align="center"
                                  type="number"
                                  style="width: 80px"
                                  min="0"
                                  @change="getMeanData(scope.row)"/>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span v-if="scope.row.approve2Price === 0">0</span>
                                <span v-else> {{parseFloat((scope.row.approve2Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.approve2Price === 0">0</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.approve2Price - scope.row.costPrice) / scope.row.approve2Price) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="scope.row.priceApplicationType === 20" style="display: flex; flex-direction: row; justify-content: space-between">
                            <div v-if="scope.row.price === scope.row.approve2Price">
                              总监:线缆: <span>{{scope.row.approve2Price}}%</span>
                            </div>
                            <div v-else>
                              总监:线缆: <span style="color: red">{{scope.row.approve2Price}}%</span>
                            </div>
                            <div v-if="scope.row.floatingPrice === scope.row.approve2FloatingPrice" style="width: 46%; text-align: left">
                              <div v-if="scope.row.floatingPriceType === 20">
                                每层加工费: <span>{{scope.row.approve2FloatingPrice}}</span>
                              </div>
                              <div v-else>
                                加工费折扣: <span>{{scope.row.approve2FloatingPrice}}%</span>
                              </div>
                            </div>
                            <div v-else style="width: 46%; text-align: left">
                              <div v-if="scope.row.floatingPriceType === 20">
                                每层加工费: <span style="color: red">{{scope.row.approve2FloatingPrice}}</span>
                              </div>
                              <div v-else>
                                加工费折扣: <span style="color: red">{{scope.row.approve2FloatingPrice}}%</span>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <div v-if="scope.row.floatingPrice === 0">
                              <div v-if="scope.row.price === scope.row.approve2Price">
                                总监:
                                <span>{{scope.row.approve2Price}}</span>
                                <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                  /毛利：
                                  <span v-if="scope.row.approve2Price === 0">0</span>
                                  <span v-else> {{parseFloat((scope.row.approve2Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                  毛利率：
                                  <span v-if="scope.row.approve2Price === 0">0</span>
                                  <span v-else>
                                    {{parseFloat(((scope.row.approve2Price - scope.row.costPrice) / scope.row.approve2Price) * 100).toFixed(2)}}
                                  </span>
                                  %
                                </span>
                              </div>
                              <div v-else>
                                总监:
                                <span style="color: red">{{scope.row.approve2Price}}</span>
                                <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                  /毛利：
                                  <span v-if="scope.row.approve2Price === 0">0</span>
                                  <span v-else> {{parseFloat((scope.row.approve2Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                  毛利率：
                                  <span v-if="scope.row.approve2Price === 0">0</span>
                                  <span v-else>
                                    {{parseFloat(((scope.row.approve2Price - scope.row.costPrice) / scope.row.approve2Price) * 100).toFixed(2)}}
                                  </span>
                                  %
                                </span>
                              </div>
                            </div>
                            <div v-else>
                              <div v-if="scope.row.price === scope.row.approve2Price">
                                总监:
                                <span>
                                  {{scope.row.approve2Price + "/" + scope.row.approve2FloatingPrice}}
                                </span>
                                <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                  /毛利：
                                  <span v-if="scope.row.approve2Price === 0">0</span>
                                  <span v-else> {{parseFloat((scope.row.approve2Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                  毛利率：
                                  <span v-if="scope.row.approve2Price === 0">0</span>
                                  <span v-else>
                                    {{parseFloat(((scope.row.approve2Price - scope.row.costPrice) / scope.row.approve2Price) * 100).toFixed(2)}}
                                  </span>
                                  %
                                </span>
                              </div>
                              <div v-else>
                                总监:
                                <span style="color: red">
                                  {{scope.row.approve2Price + "/" + scope.row.approve2FloatingPrice}}
                                </span>
                                <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                  /毛利：
                                  <span v-if="scope.row.approve2Price === 0">0</span>
                                  <span v-else> {{parseFloat((scope.row.approve2Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                  毛利率：
                                  <span v-if="scope.row.approve2Price === 0">0</span>
                                  <span v-else>
                                    {{parseFloat(((scope.row.approve2Price - scope.row.costPrice) / scope.row.approve2Price) * 100).toFixed(2)}}
                                  </span>
                                  %
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!--20-->
                      <div>
                        <div v-if="businessApplicationVO.approveStatus === 20">
                          <div v-if="scope.row.priceApplicationType === 20" style="display: flex; flex-direction: row; justify-content: space-between">
                            <div>
                              财务总监:线缆:
                              <el-input
                                  v-model="scope.row.finApprovePrice"
                                  align="center"
                                  type="number"
                                  style="width: 80px"
                                  min="0"
                                  @change="isChangeFunction(scope.row)"/>%
                            </div>
                            <div v-if="scope.row.floatingPriceType === 20" style="width: 46%; text-align: left">
                              每层加工费:
                              <el-input
                                  v-model="scope.row.finApproveFloatingPrice"
                                  align="center"
                                  type="number"
                                  style="width: 80px"
                                  min="0"
                                  @change="isChangeFunction(scope.row)"/>
                            </div>
                            <div v-else style="width: 46%; text-align: left">
                              加工费折扣:
                              <el-input
                                  v-model="scope.row.finApproveFloatingPrice"
                                  align="center"
                                  type="number"
                                  style="width: 80px"
                                  min="0"
                                  @change="isChangeFunction(scope.row)"/>%
                            </div>
                          </div>
                          <div v-else>
                            <div v-if="scope.row.floatingPrice === 0">
                              财务总监:
                              <el-input
                                  v-model="scope.row.finApprovePrice"
                                  align="center"
                                  type="number"
                                  style="width: 80px"
                                  min="0"
                                  @change="getMeanData(scope.row)"/>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span v-if="scope.row.finApprovePrice === 0">0</span>
                                <span v-else> {{parseFloat((scope.row.finApprovePrice - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.finApprovePrice === 0">0</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.finApprovePrice - scope.row.costPrice) / scope.row.finApprovePrice) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                            <div v-else>
                              财务总监:
                              <el-input
                                  v-model="scope.row.finApprovePrice"
                                  align="center"
                                  type="number"
                                  style="width: 80px"
                                  min="0"
                                  @change="getMeanData(scope.row)"/>
                              <el-input
                                  v-model="scope.row.finApproveFloatingPrice"
                                  align="center"
                                  type="number"
                                  style="width: 80px"
                                  min="0"
                                  @change="getMeanData(scope.row)"/>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span v-if="scope.row.finApprovePrice === 0">0</span>
                                <span v-else> {{parseFloat((scope.row.finApprovePrice - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.finApprovePrice === 0">0</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.finApprovePrice - scope.row.costPrice) / scope.row.finApprovePrice) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="scope.row.priceApplicationType === 20" style="display: flex; flex-direction: row; justify-content: space-between">
                            <div v-if="scope.row.price === scope.row.finApprovePrice">
                              财务总监:线缆: <span>{{scope.row.finApprovePrice}}%</span>
                            </div>
                            <div v-else>
                              财务总监:线缆: <span style="color: red">{{scope.row.finApprovePrice}}%</span>
                            </div>
                            <div v-if="scope.row.floatingPrice === scope.row.finApproveFloatingPrice" style="width: 46%; text-align: left">
                              <div v-if="scope.row.floatingPriceType === 20">
                                每层加工费: <span>{{scope.row.finApproveFloatingPrice}}</span>
                              </div>
                              <div v-else>
                                加工费折扣: <span>{{scope.row.finApproveFloatingPrice}}%</span>
                              </div>
                            </div>
                            <div v-else style="width: 46%; text-align: left">
                              <div v-if="scope.row.floatingPriceType === 20">
                                每层加工费: <span style="color: red">{{scope.row.finApproveFloatingPrice}}</span>
                              </div>
                              <div v-else>
                                加工费折扣: <span style="color: red">{{scope.row.finApproveFloatingPrice}}%</span>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <div v-if="scope.row.floatingPrice === 0">
                              <div v-if="scope.row.price === scope.row.finApprovePrice">
                                财务总监:
                                <span>{{scope.row.finApprovePrice}}</span>
                                <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                  /毛利：
                                  <span v-if="scope.row.finApprovePrice === 0">0</span>
                                  <span v-else> {{parseFloat((scope.row.finApprovePrice - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                  毛利率：
                                  <span v-if="scope.row.finApprovePrice === 0">0</span>
                                  <span v-else>
                                    {{parseFloat(((scope.row.finApprovePrice - scope.row.costPrice) / scope.row.finApprovePrice) * 100).toFixed(2)}}
                                  </span>
                                  %
                                </span>
                              </div>
                              <div v-else>
                                财务总监:
                                <span style="color: red">{{scope.row.finApprovePrice}}</span>
                                <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                  /毛利：
                                  <span v-if="scope.row.finApprovePrice === 0">0</span>
                                  <span v-else> {{parseFloat((scope.row.finApprovePrice - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                  毛利率：
                                  <span v-if="scope.row.finApprovePrice === 0">0</span>
                                  <span v-else>
                                    {{parseFloat(((scope.row.finApprovePrice - scope.row.costPrice) / scope.row.finApprovePrice) * 100).toFixed(2)}}
                                  </span>
                                  %
                                </span>
                              </div>
                            </div>
                            <div v-else>
                              <div v-if="scope.row.price === scope.row.finApprovePrice">
                                财务总监:
                                <span>
                                  {{scope.row.finApprovePrice + "/" + scope.row.finApproveFloatingPrice}}
                                </span>
                                <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                  /毛利：
                                  <span v-if="scope.row.finApprovePrice === 0">0</span>
                                  <span v-else> {{parseFloat((scope.row.finApprovePrice - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                  毛利率：
                                  <span v-if="scope.row.finApprovePrice === 0">0</span>
                                  <span v-else>
                                    {{parseFloat(((scope.row.finApprovePrice - scope.row.costPrice) / scope.row.finApprovePrice) * 100).toFixed(2)}}
                                  </span>
                                  %
                                </span>
                              </div>
                              <div v-else>
                                财务总监:
                                <span style="color: red">
                                  {{scope.row.finApprovePrice + "/" + scope.row.finApproveFloatingPrice}}
                                </span>
                                <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                  /毛利：
                                  <span v-if="scope.row.finApprovePrice === 0">0</span>
                                  <span v-else> {{parseFloat((scope.row.finApprovePrice - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                  毛利率：
                                  <span v-if="scope.row.finApprovePrice === 0">0</span>
                                  <span v-else>
                                    {{parseFloat(((scope.row.finApprovePrice - scope.row.costPrice) / scope.row.finApprovePrice) * 100).toFixed(2)}}
                                  </span>
                                  %
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!--3-->
                      <div>
                        <div v-if="businessApplicationVO.approveStatus === 3">
                          <div v-if="scope.row.priceApplicationType === 20" style="display: flex; flex-direction: row; justify-content: space-between">
                            <div>
                              总经理:线缆:
                              <el-input
                                  v-model="scope.row.approve3Price"
                                  align="center"
                                  type="number"
                                  style="width: 80px"
                                  min="0"
                                  @change="isChangeFunction(scope.row)"/>%
                            </div>
                            <div v-if="scope.row.floatingPriceType === 20" style="width: 46%; text-align: left">
                              每层加工费:
                              <el-input
                                  v-model="scope.row.approve3FloatingPrice"
                                  align="center"
                                  type="number"
                                  style="width: 80px"
                                  min="0"
                                  @change="isChangeFunction(scope.row)"/>
                            </div>
                            <div v-else style="width: 46%; text-align: left">
                              加工费折扣:
                              <el-input
                                  v-model="scope.row.approve3FloatingPrice"
                                  align="center"
                                  type="number"
                                  style="width: 80px"
                                  min="0"
                                  @change="isChangeFunction(scope.row)"/>%
                            </div>
                          </div>
                          <div v-else>
                            <div v-if="scope.row.floatingPrice === 0">
                              总经理:
                              <el-input
                                  v-model="scope.row.approve3Price"
                                  align="center"
                                  type="number"
                                  style="width: 80px"
                                  min="0"
                                  @change="getMeanData(scope.row)"/>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span> {{parseFloat((scope.row.approve3Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.approve3Price === 0">0,</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.approve3Price - scope.row.costPrice) / scope.row.approve3Price) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                            <div v-else>
                              总经理:
                              <el-input
                                  v-model="scope.row.approve3Price"
                                  align="center"
                                  type="number"
                                  style="width: 80px"
                                  min="0"
                                  @change="getMeanData(scope.row)"/>
                              <el-input
                                  v-model="scope.row.approve3FloatingPrice"
                                  align="center"
                                  type="number"
                                  style="width: 80px"
                                  min="0"
                                  @change="getMeanData(scope.row)"/>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span> {{parseFloat((scope.row.approve3Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.approve3Price === 0">0,</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.approve3Price - scope.row.costPrice) / scope.row.approve3Price) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="scope.row.priceApplicationType === 20" style="display: flex; flex-direction: row; justify-content: space-between">
                            <div v-if="scope.row.price === scope.row.approve3Price">
                              总经理:线缆: <span>{{scope.row.approve3Price}}%</span>
                            </div>
                            <div v-else>
                              总经理:线缆: <span style="color: red">{{scope.row.approve3Price}}%</span>
                            </div>
                            <div v-if="scope.row.floatingPrice === scope.row.approve3FloatingPrice" style="width: 46%; text-align: left">
                              <div v-if="scope.row.floatingPriceType === 20">
                                每层加工费: <span>{{scope.row.approve3FloatingPrice}}</span>
                              </div>
                              <div v-else>
                                加工费折扣: <span>{{scope.row.approve3FloatingPrice}}%</span>
                              </div>
                            </div>
                            <div v-else style="width: 46%; text-align: left">
                              <div v-if="scope.row.floatingPriceType === 20">
                                每层加工费: <span style="color: red">{{scope.row.approve3FloatingPrice}}</span>
                              </div>
                              <div v-else>
                                加工费折扣: <span style="color: red">{{scope.row.approve3FloatingPrice}}%</span>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <div v-if="scope.row.floatingPrice === 0">
                              <div v-if="scope.row.price === scope.row.approve3Price">
                                总经理:
                                <span>{{scope.row.approve3Price}}</span>
                                <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                  /毛利：
                                  <span> {{parseFloat((scope.row.approve3Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                  毛利率：
                                  <span v-if="scope.row.approve3Price === 0">0,</span>
                                  <span v-else>
                                    {{parseFloat(((scope.row.approve3Price - scope.row.costPrice) / scope.row.approve3Price) * 100).toFixed(2)}}
                                  </span>
                                  %
                                </span>
                              </div>
                              <div v-else>
                                总经理:
                                <span style="color: red">{{scope.row.approve3Price}}</span>
                                <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                  /毛利：
                                  <span> {{parseFloat((scope.row.approve3Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                  毛利率：
                                  <span v-if="scope.row.approve3Price === 0">0,</span>
                                  <span v-else>
                                    {{parseFloat(((scope.row.approve3Price - scope.row.costPrice) / scope.row.approve3Price) * 100).toFixed(2)}}
                                  </span>
                                  %
                                </span>
                              </div>
                            </div>
                            <div v-else>
                              <div v-if="scope.row.price === scope.row.approve3Price">
                                总经理:
                                <span>
                                  {{scope.row.approve3Price + "/" + scope.row.approve3FloatingPrice}}
                                </span>
                                <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                  /毛利：
                                  <span> {{parseFloat((scope.row.approve3Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                  毛利率：
                                  <span v-if="scope.row.approve3Price === 0">0,</span>
                                  <span v-else>
                                    {{parseFloat(((scope.row.approve3Price - scope.row.costPrice) / scope.row.approve3Price) * 100).toFixed(2)}}
                                  </span>
                                  %
                                </span>
                              </div>
                              <div v-else>
                                总经理:
                                <span style="color: red">
                                  {{scope.row.approve3Price + "/" + scope.row.approve3FloatingPrice}}
                                </span>
                                <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                  /毛利：
                                  <span> {{parseFloat((scope.row.approve3Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                  毛利率：
                                  <span v-if="scope.row.approve3Price === 0">0,</span>
                                  <span v-else>
                                    {{parseFloat(((scope.row.approve3Price - scope.row.costPrice) / scope.row.approve3Price) * 100).toFixed(2)}}
                                  </span>
                                  %
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="备注" prop="note"/>
                </el-table>
                <div style="width: 100%;display: flex;flex-direction: row;align-items: center;background: #f4f7fa">
                  <div class="businessApplicationDetails-word">选配产品</div>
                  <div class="historyBtn" style="color: #2d8cf0; font-size: 12px; margin-left: 1%; cursor: pointer" @click="changeOptionalPriceVOS()">
                    {{isShow ? "隐藏" : "展开"}}
                    <el-button :icon="isShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"/>
                  </div>
                </div>
                <el-table
                    v-if="isShow"
                    ref="multipleTable1"
                    row-key="id"
                    :data="props.row.optionalPriceVOS"
                    style="width: 100%">
                  <el-table-column label="特性" prop="propertyName" width="350">
                    <template slot-scope="scope">
                      <span>{{scope.row.propertyName}}:{{scope.row.displayValue}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="执行价" width="150">
                    <template slot-scope="scope">
                      <div>
                        成本价：
                        <span v-if="businessApplicationVO.costVisible === true">
                          {{scope.row.costPrice}}
                        </span>
                        <span v-else>
                          ***
                        </span>
                      </div>
                      <div>
                        销售员价：
                        <span>
                          {{scope.row.sellingPrice}}
                        </span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="申请价格" width="180" prop="price">
                    <template slot-scope="scope">
                      <div>{{scope.row.price}}</div>
                      <div v-if="costLookAuth" style="color: #ff7e00">
                        毛利：
                        <span>
                          {{parseFloat((scope.row.price - scope.row.costPrice) / 1.13).toFixed(2)}}
                        </span>
                      </div>
                      <div v-if="costLookAuth" style="color: #ff7e00">
                        毛利率：
                        <span v-if="scope.row.price === 0">0</span>
                        <span v-else>
                          {{parseFloat(((scope.row.price - scope.row.costPrice) / scope.row.price) * 100).toFixed(2)}}
                        </span>
                        %
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column width="400" label="审核价格">
                    <template slot-scope="scope">
                      <div>
                        营销中心审核价格:
                        <el-input v-model="scope.row.approve1Price" style="width: 20%;" :disabled="nodeId !== 'MarketCenterApprove'" @change="isChangeFunction(scope.row)"/>
                        <div v-if="costLookAuth">
                          <span style="color: #ff7e00">
                            /毛利：
                            <span> {{parseFloat((scope.row.approve1Price - scope.row.costPrice) / 1.13).toFixed(2)}}%, </span>
                            毛利率：
                            <span v-if="scope.row.approve1Price === 0">0</span>
                            <span v-else> {{parseFloat(((scope.row.approve1Price - scope.row.costPrice) / scope.row.approve1Price) * 100).toFixed(2)}}% </span>
                          </span>
                        </div>
                      </div>
                      <div>
                        营销总监审核价格:
                        <el-input v-model="scope.row.approve2Price" style="width: 20%;" :disabled="nodeId !== 'MCDApprove'" @change="isChangeFunction(scope.row)"/>
                        <div v-if="costLookAuth">
                          <span style="color: #ff7e00">
                            /毛利：
                            <span> {{parseFloat((scope.row.approve2Price - scope.row.costPrice) / 1.13).toFixed(2)}}%, </span>
                            毛利率：
                            <span v-if="scope.row.approve2Price === 0">0</span>
                            <span v-else> {{parseFloat(((scope.row.approve2Price - scope.row.costPrice) / scope.row.approve2Price) * 100).toFixed(2)}}% </span>
                          </span>
                        </div>
                      </div>
                      <div>
                        总经理审核价格:
                        <el-input v-model="scope.row.approve3Price" style="width: 20%;" :disabled="nodeId !== 'GeneralManager'" @change="isChangeFunction(scope.row)"/>
                        <div v-if="costLookAuth">
                          <span style="color: #ff7e00">
                            /毛利：
                            <span> {{parseFloat((scope.row.approve3Price - scope.row.costPrice) / 1.13).toFixed(2)}}%, </span>
                            毛利率：
                            <span v-if="scope.row.approve3Price === 0">0</span>
                            <span v-else> {{parseFloat(((scope.row.approve3Price - scope.row.costPrice) / scope.row.approve3Price) * 100).toFixed(2)}}% </span>
                          </span>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="备注" prop="note"/>
                </el-table>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column prop="productName">
            <template slot-scope="scope">
              <span style="font-weight: bold">{{scope.row.productName}}</span>
              <span v-if="scope.row.optionalPriceVOS.length > 0" style="color: red">(有选配)</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="businessApplicationDetails-seond-bottom" style="position: relative; margin-top: 1%">
        <div style="width: 100%; border-bottom: 1px solid #dddddd; background: #f4f7fa; display: flex; flex-direction: row; -webkit-align-content: center; align-items: center; position: absolute; top: -3px; left: 0; z-index: 999; border-top: 1px solid #dddddd">
          <div style="font-size: 14px">
            <div class="businessApplicationDetails-word" style="border-bottom: none; width: 90px; margin-left: 5px">历史申请记录</div>
          </div>
          <div class="historyBtn" style="color: #2d8cf0; font-size: 12px; margin-left: 1%; cursor: pointer" @click="changeIsHidden">
            {{isHidden ? "全部隐藏" : "全部展开"}}
            <el-button v-if="loading" :loading="loading"/>
            <el-button v-else :icon="isHidden ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"/>
          </div>
        </div>
        <el-table ref="multipleTable" :data="businessApplicationVO.allApplicationPriceWrapperS" style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table :data="props.row.paDetailVOS" style="width: 90%; margin: 0 auto">
                <el-table-column prop="nameValues" label="特性">
                  <template slot-scope="scope">
                    <span v-if="scope.row.priceApplicationType ===20 && scope.row.applicationType === 10">{{scope.row.param1}}</span>
                    <span v-if="scope.row.priceApplicationType ===20 && scope.row.applicationType === 20">{{scope.row.nameValues}}</span>
                    <div v-else>
                      <span v-if="businessApplicationVO.costVisible === true" style="color: #2d8cf0; cursor: pointer" @click="$refs.preview.open(scope.row)">
                        {{scope.row.nameValues}}
                      </span>
                      <span v-else>{{scope.row.nameValues}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="申请类型" prop="executePrice">
                  <template slot-scope="scope">
                    <div v-if="scope.row.applicationType === 10">按产品申请</div>
                    <div v-if="scope.row.applicationType === 20">按规格申请</div>
                  </template>
                </el-table-column>
                <el-table-column label="执行价" prop="executePrice">
                  <template slot-scope="scope">
                    <div v-if="scope.row.priceApplicationType === 20">申请折扣</div>
                    <div v-else>
                      <div v-if="scope.row.standardFloatingPrice === 0">
                        <div v-if="businessApplicationVO.costVisible === true">
                          {{"成本价:" + scope.row.costPrice}}
                        </div>
                        <div :style="businessApplicationVO.applicantPositon === 1 ? 'font-weight: 500' : 'font-weight: bold'">销售员:{{scope.row.level1Price}}</div>
                        <div v-if="props.row.userPosition !== 1">
                          {{"区总:" + scope.row.level2Price}}
                        </div>
                        <div v-if="props.row.userPosition !== 1 && props.row.userPosition !== 2">
                          {{"总监:" + scope.row.level3Price}}
                        </div>
                      </div>
                      <div v-else>
                        <div v-if="businessApplicationVO.costVisible === true">
                          {{"成本价:" + scope.row.costPrice + "/" + scope.row.costFloatingPrice}}
                        </div>
                        <div :style="businessApplicationVO.applicantPositon === 1 ? 'font-weight: 500' : 'font-weight: bold'">销售员:{{scope.row.level1Price + "/" + scope.row.level1FloatingPrice}}</div>
                        <div v-if="props.row.userPosition !== 1">
                          {{"区总:" + scope.row.level2Price + "/" + scope.row.level2FloatingPrice}}
                        </div>
                        <div v-if="props.row.userPosition !== 1 && props.row.userPosition !== 2">
                          {{"总监:" + scope.row.level3Price + "/" + scope.row.level3FloatingPrice}}
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="申请价格" prop="applicationPrice">
                  <template slot-scope="scope">
                    <div v-if="scope.row.priceApplicationType === 20">
                      <div v-if="scope.row.floatingPriceType === 20">
                        <div>线缆单价折扣:{{scope.row.price}}%</div>
                        <div>每层加工费:{{scope.row.floatingPrice}}</div>
                      </div>
                      <div v-else>
                        <div>线缆单价折扣:{{scope.row.price}}%</div>
                        <div>加工费折扣:{{scope.row.floatingPrice}}%</div>
                      </div>
                    </div>
                    <div v-else>
                      <div v-if="scope.row.floatingPrice === 0">
                        {{scope.row.price}}
                        <div v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                          <div>
                            毛利：
                            <span>
                              {{parseFloat((scope.row.price - scope.row.costPrice) / 1.13).toFixed(2)}}
                            </span>
                          </div>
                          <div>
                            毛利率：
                            <span v-if="scope.row.price === 0">0</span>
                            <span v-else>
                              {{parseFloat(((scope.row.price - scope.row.costPrice) / scope.row.price) * 100).toFixed(2)}}
                            </span>
                            %
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        {{scope.row.price + "/" + scope.row.floatingPrice}}
                        <div v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                          <div>
                            毛利：
                            <span>
                              {{parseFloat((scope.row.price - scope.row.costPrice) / 1.13).toFixed(2)}}
                            </span>
                          </div>
                          <div>
                            毛利率：
                            <span v-if="scope.row.price === 0">0</span>
                            <span v-else>
                              {{parseFloat(((scope.row.price - scope.row.costPrice) / scope.row.price) * 100).toFixed(2)}}
                            </span>
                            %
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column width="350" label="审核价格" prop="mainRepairMan">
                  <template slot-scope="scope">
                    <div v-if="scope.row.priceApplicationType === 20" style="display: flex; flex-direction: row">
                      <div style="width: 50%; text-align: center">
                        <div v-if="scope.row.price === scope.row.approve1Price">
                          营销中心:线缆: <span>{{scope.row.approve1Price}}%</span>
                        </div>
                        <div v-else>
                          营销中心:线缆: <span style="color: red">{{scope.row.approve1Price}}%</span>
                        </div>

                        <div v-if="scope.row.price === scope.row.approve2Price">
                          总监:线缆: <span>{{scope.row.approve2Price}}%</span>
                        </div>
                        <div v-else>
                          总监:线缆: <span style="color: red">{{scope.row.approve2Price}}%</span>
                        </div>

                        <div v-if="scope.row.price === scope.row.finApprovePrice">
                          财务总监:线缆: <span>{{scope.row.finApprovePrice}}%</span>
                        </div>
                        <div v-else>
                          财务总监:线缆:
                          <span style="color: red"> {{scope.row.finApprovePrice}}% </span>
                        </div>

                        <div v-if="scope.row.price === scope.row.approve3Price">
                          总经理:线缆: <span>{{scope.row.approve3Price}}%</span>
                        </div>
                        <div v-else>
                          总经理:线缆: <span style="color: red">{{scope.row.approve3Price}}%</span>
                        </div>
                      </div>
                      <div style="width: 50%; text-align: center">
                        <div v-if="scope.row.floatingPrice === scope.row.approve1FloatingPrice">
                          <div v-if="scope.row.floatingPriceType === 20">
                            每层加工费: <span>{{scope.row.approve1FloatingPrice}}</span>
                          </div>
                          <div v-else>
                            加工费折扣: <span>{{scope.row.approve1FloatingPrice}}%</span>
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="scope.row.floatingPriceType === 20">
                            每层加工费: <span style="color: red">{{scope.row.approve1FloatingPrice}}</span>
                          </div>
                          <div v-else>
                            加工费折扣: <span style="color: red">{{scope.row.approve1FloatingPrice}}%</span>
                          </div>
                        </div>

                        <div v-if="scope.row.floatingPrice === scope.row.approve2FloatingPrice">
                          <div v-if="scope.row.floatingPriceType === 20">
                            每层加工费: <span>{{scope.row.approve2FloatingPrice}}</span>
                          </div>
                          <div v-else>
                            加工费折扣: <span>{{scope.row.approve2FloatingPrice}}%</span>
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="scope.row.floatingPriceType === 20">
                            每层加工费: <span style="color: red">{{scope.row.approve2FloatingPrice}}</span>
                          </div>
                          <div v-else>
                            加工费折扣: <span style="color: red">{{scope.row.approve2FloatingPrice}}%</span>
                          </div>
                        </div>

                        <div v-if="scope.row.floatingPrice === scope.row.finApproveFloatingPrice">
                          <div v-if="scope.row.floatingPriceType === 20">
                            每层加工费: <span>{{scope.row.finApproveFloatingPrice}}</span>
                          </div>
                          <div v-else>
                            加工费折扣: <span>{{scope.row.finApproveFloatingPrice}}%</span>
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="scope.row.floatingPriceType === 20">
                            每层加工费: <span style="color: red">{{scope.row.finApproveFloatingPrice}}</span>
                          </div>
                          <div v-else>
                            加工费折扣: <span style="color: red">{{scope.row.finApproveFloatingPrice}}%</span>
                          </div>
                        </div>

                        <div v-if="scope.row.floatingPrice === scope.row.approve3FloatingPrice">
                          <div v-if="scope.row.floatingPriceType === 20">
                            每层加工费: <span>{{scope.row.approve3FloatingPrice}}</span>
                          </div>
                          <div v-else>
                            加工费折扣: <span>{{scope.row.approve3FloatingPrice}}%</span>
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="scope.row.floatingPriceType === 20">
                            每层加工费: <span style="color: red">{{scope.row.approve3FloatingPrice}}</span>
                          </div>
                          <div v-else>
                            加工费折扣: <span style="color: red">{{scope.row.approve3FloatingPrice}}%</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div v-if="scope.row.floatingPrice === 0">
                        <div v-if="scope.row.price === scope.row.approve1Price">
                          营销中心:
                          <span>{{scope.row.approve1Price}}</span>
                          <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                            /毛利：
                            <span> {{parseFloat((scope.row.approve1Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                            毛利率：
                            <span v-if="scope.row.approve1Price === 0">0</span>
                            <span v-else>
                              {{parseFloat(((scope.row.approve1Price - scope.row.costPrice) / scope.row.approve1Price) * 100).toFixed(2)}}
                            </span>
                            %
                          </span>
                        </div>
                        <div v-else>
                          营销中心:
                          <span style="color: red">{{scope.row.approve1Price}}</span>
                          <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                            /毛利：
                            <span> {{parseFloat((scope.row.approve1Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                            毛利率：
                            <span v-if="scope.row.approve1Price === 0">0</span>
                            <span v-else>
                              {{parseFloat(((scope.row.approve1Price - scope.row.costPrice) / scope.row.approve1Price) * 100).toFixed(2)}}
                            </span>
                            %
                          </span>
                        </div>
                        <div v-if="scope.row.price === scope.row.approve2Price">
                          总监:
                          <span>{{scope.row.approve2Price}}</span>
                          <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                            /毛利：
                            <span> {{parseFloat((scope.row.approve2Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                            毛利率：
                            <span v-if="scope.row.approve2Price === 0">0</span>
                            <span v-else>
                              {{parseFloat(((scope.row.approve2Price - scope.row.costPrice) / scope.row.approve2Price) * 100).toFixed(2)}}
                            </span>
                            %
                          </span>
                        </div>
                        <div v-else>
                          总监:
                          <span style="color: red">{{scope.row.approve2Price}}</span>
                          <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                            /毛利：
                            <span> {{parseFloat((scope.row.approve2Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                            毛利率：
                            <span v-if="scope.row.approve2Price === 0">0</span>
                            <span v-else>
                              {{parseFloat(((scope.row.approve2Price - scope.row.costPrice) / scope.row.approve2Price) * 100).toFixed(2)}}
                            </span>
                            %
                          </span>
                        </div>
                        <div v-if="scope.row.price === scope.row.finApprovePrice">
                          财务总监:
                          <span>{{scope.row.finApprovePrice}}</span>
                          <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                            /毛利：
                            <span> {{parseFloat((scope.row.finApprovePrice - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                            毛利率：
                            <span v-if="scope.row.finApprovePrice === 0">0</span>
                            <span v-else>
                              {{parseFloat(((scope.row.finApprovePrice - scope.row.costPrice) / scope.row.finApprovePrice) * 100).toFixed(2)}}
                            </span>
                            %
                          </span>
                        </div>
                        <div v-else>
                          财务总监:
                          <span style="color: red">{{scope.row.finApprovePrice}}</span>
                          <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                            /毛利：
                            <span> {{parseFloat((scope.row.finApprovePrice - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                            毛利率：
                            <span v-if="scope.row.finApprovePrice === 0">0</span>
                            <span v-else>
                              {{parseFloat(((scope.row.finApprovePrice - scope.row.costPrice) / scope.row.finApprovePrice) * 100).toFixed(2)}}
                            </span>
                            %
                          </span>
                        </div>
                        <div v-if="scope.row.price === scope.row.approve3Price">
                          总经理:
                          <span>{{scope.row.approve3Price}}</span>
                          <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                            /毛利：
                            <span> {{parseFloat((scope.row.approve3Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                            毛利率：
                            <span v-if="scope.row.approve3Price === 0">0,</span>
                            <span v-else>
                              {{parseFloat(((scope.row.approve3Price - scope.row.costPrice) / scope.row.approve3Price) * 100).toFixed(2)}}
                            </span>
                            %
                          </span>
                        </div>
                        <div v-else>
                          总经理:
                          <span style="color: red">{{scope.row.approve3Price}}</span>
                          <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                            /毛利：
                            <span> {{parseFloat((scope.row.approve3Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                            毛利率：
                            <span v-if="scope.row.approve3Price === 0">0,</span>
                            <span v-else>
                              {{parseFloat(((scope.row.approve3Price - scope.row.costPrice) / scope.row.approve3Price) * 100).toFixed(2)}}
                            </span>
                            %
                          </span>
                        </div>
                      </div>
                      <div v-else>
                        <div v-if="scope.row.price === scope.row.approve1Price">
                          营销中心
                          <span>
                            {{scope.row.approve1Price + "/" + scope.row.approve1FloatingPrice}}
                          </span>
                          <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                            /毛利：
                            <span> {{parseFloat((scope.row.approve1Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                            毛利率：
                            <span v-if="scope.row.approve1Price === 0">0</span>
                            <span v-else>
                              {{parseFloat(((scope.row.approve1Price - scope.row.costPrice) / scope.row.approve1Price) * 100).toFixed(2)}}
                            </span>
                            %
                          </span>
                        </div>
                        <div v-else>
                          营销中心
                          <span style="color: red">
                            {{scope.row.approve1Price + "/" + scope.row.approve1FloatingPrice}}
                          </span>
                          <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                            /毛利：
                            <span> {{parseFloat((scope.row.approve1Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                            毛利率：
                            <span v-if="scope.row.approve1Price === 0">0</span>
                            <span v-else>
                              {{parseFloat(((scope.row.approve1Price - scope.row.costPrice) / scope.row.approve1Price) * 100).toFixed(2)}}
                            </span>
                            %
                          </span>
                        </div>
                        <div v-if="scope.row.price === scope.row.approve2Price">
                          总监:
                          <span>
                            {{scope.row.approve2Price + "/" + scope.row.approve2FloatingPrice}}
                          </span>
                          <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                            /毛利：
                            <span> {{parseFloat((scope.row.approve2Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                            毛利率：
                            <span v-if="scope.row.approve2Price === 0">0</span>
                            <span v-else>
                              {{parseFloat(((scope.row.approve2Price - scope.row.costPrice) / scope.row.approve2Price) * 100).toFixed(2)}}
                            </span>
                            %
                          </span>
                        </div>
                        <div v-else>
                          总监:
                          <span style="color: red">
                            {{scope.row.approve2Price + "/" + scope.row.approve2FloatingPrice}}
                          </span>
                          <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                            /毛利：
                            <span> {{parseFloat((scope.row.approve2Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                            毛利率：
                            <span v-if="scope.row.approve2Price === 0">0</span>
                            <span v-else>
                              {{parseFloat(((scope.row.approve2Price - scope.row.costPrice) / scope.row.approve2Price) * 100).toFixed(2)}}
                            </span>
                            %
                          </span>
                        </div>
                        <div v-if="scope.row.price === scope.row.finApprovePrice">
                          财务总监:
                          <span>
                            {{scope.row.finApprovePrice + "/" + scope.row.finApproveFloatingPrice}}
                          </span>
                          <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                            /毛利：
                            <span> {{parseFloat((scope.row.finApprovePrice - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                            毛利率：
                            <span v-if="scope.row.finApprovePrice === 0">0</span>
                            <span v-else>
                              {{parseFloat(((scope.row.finApprovePrice - scope.row.costPrice) / scope.row.finApprovePrice) * 100).toFixed(2)}}
                            </span>
                            %
                          </span>
                        </div>
                        <div v-else>
                          财务总监:
                          <span style="color: red">
                            {{scope.row.finApprovePrice + "/" + scope.row.finApproveFloatingPrice}}
                          </span>
                          <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                            /毛利：
                            <span> {{parseFloat((scope.row.finApprovePrice - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                            毛利率：
                            <span v-if="scope.row.finApprovePrice === 0">0</span>
                            <span v-else>
                              {{parseFloat(((scope.row.finApprovePrice - scope.row.costPrice) / scope.row.finApprovePrice) * 100).toFixed(2)}}
                            </span>
                            %
                          </span>
                        </div>
                        <div v-if="scope.row.price === scope.row.approve3Price">
                          总经理:
                          <span>
                            {{scope.row.approve3Price + "/" + scope.row.approve3FloatingPrice}}
                          </span>
                          <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                            /毛利：
                            <span> {{parseFloat((scope.row.approve3Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                            毛利率：
                            <span v-if="scope.row.approve3Price === 0">0,</span>
                            <span v-else>
                              {{parseFloat(((scope.row.approve3Price - scope.row.costPrice) / scope.row.approve3Price) * 100).toFixed(2)}}
                            </span>
                            %
                          </span>
                        </div>
                        <div v-else>
                          总经理:
                          <span style="color: red">
                            {{scope.row.approve3Price + "/" + scope.row.approve3FloatingPrice}}
                          </span>
                          <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                            /毛利：
                            <span> {{parseFloat((scope.row.approve3Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                            毛利率：
                            <span v-if="scope.row.approve3Price === 0">0,</span>
                            <span v-else>
                              {{parseFloat(((scope.row.approve3Price - scope.row.costPrice) / scope.row.approve3Price) * 100).toFixed(2)}}
                            </span>
                            %
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <!--<el-table-column label="备注" prop="note"/>-->
              </el-table>
            </template>
          </el-table-column>
          <el-table-column prop="productName">
            <template slot-scope="scope">
              <span style="font-weight: bold">{{scope.row.productName}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <same-customer-level-dialog ref="preview" @save-success="getData()"/>
    <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
  </div>
</template>

<script>
  import constant from "../../util/constant";
  import SameCustomerLevelDialog from "@/views/salesManage/businessApplication/SameCustomerLevelDialog";
  import HandleDetail from "@/views/workFlow/HandleDetail";

  export default {
    name: "BusinessApplicationPreview",
    components: { SameCustomerLevelDialog, HandleDetail },
    props: {
      billId: {
        type: String,
        required: true,
      },
      billType: {
        type: String,
        required: true,
      },
      sequId: {
        type: String,
        required: true,
      },
      params: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        costLookAuth: this.$auth(250),
        dialogVisible: false,
        loading: false,
        constant,
        businessApplicationVO: {
          applicationPriceWrapperS: [],
          optionalPriceVOS: [],
        },
        nodeId: "",
        isHidden: false,
        isShow: true,
        expands: [],
        ruleValidate: {
          orderNo: { required: true, message: "不能为空", trigger: "blur" },
        },
      };
    },
    watch: {
      params: {
        handler() {
          this.doApprove();
        },
      },
    // "businessApplicationVO.applicationPriceWrapperS": {
    //   deep: true,
    //   handler(newVal,oldVal) {
    //     if (newVal!==oldVal) {
    //       this.getMeanData(newVal);
    //     }
    //   },
    // },
    },
    mounted() {
      this.getData();
      this.expands.push(1);
    },
    methods: {
      getData() {
        this.$emit("loading-status", { loading: true });
        this.$http.get("basic", `sd/ba/${this.billId}/${this.sequId}`).then((resp) => {
          console.log(resp.applicationPriceWrapperS);
          this.$emit("loading-status", { loading: false });
          this.businessApplicationVO = resp;
          //this.getMeanData()
          console.log(this.businessApplicationVO.approveStatus);
          this.getNodeValue();
        });
      },
      getMeanData(row) {
        row.isChange = true;
        console.log("实时获取平均毛利率");
        let priceSum = 0;
        let costSum = 0;
        let approve1Sum = 0;
        let approve2Sum = 0;
        let approve3Sum = 0;
        let finApproveSum = 0;
        for (let item of this.businessApplicationVO.applicationPriceWrapperS) {
          for (let item1 of item.paDetailVOS) {
            if (item1.price != null && item1.priceApplicationType !== 20) {
              priceSum += parseFloat(item1.price);
            }
            if (item1.costPrice != null && item1.priceApplicationType !== 20) {
              costSum += parseFloat(item1.costPrice);
            }
            if (item1.approve1Price != null && item1.priceApplicationType !== 20) {
              approve1Sum += parseFloat(item1.approve1Price);
            }
            if (item1.approve2Price != null && item1.priceApplicationType !== 20) {
              approve2Sum += parseFloat(item1.approve2Price);
            }
            if (item1.approve3Price != null && item1.priceApplicationType !== 20) {
              console.log(item1.approve3Price);
              approve3Sum += parseFloat(item1.approve3Price);
            }
            if (item1.finApprovePrice != null && item1.priceApplicationType !== 20) {
              finApproveSum += parseFloat(item1.finApprovePrice);
            }
          }
        }
        this.businessApplicationVO.applicationAvgPercent = Math.round(((priceSum - costSum) / priceSum) * 100 * 100) / 100.0;
        this.businessApplicationVO.approve1AvgPercent = Math.round(((approve1Sum - costSum) / approve1Sum) * 100 * 100) / 100.0;
        this.businessApplicationVO.approve2AvgPercent = Math.round(((approve2Sum - costSum) / approve2Sum) * 100 * 100) / 100.0;
        this.businessApplicationVO.approve3AvgPercent = Math.round(((approve3Sum - costSum) / approve3Sum) * 100 * 100) / 100.0;
        this.businessApplicationVO.finApproveAvgPercent = Math.round(((finApproveSum - costSum) / finApproveSum) * 100 * 100) / 100.0;
        console.log(priceSum, costSum, approve1Sum, approve2Sum, approve3Sum, finApproveSum);
      },
      isChangeFunction(row) {
        row.isChange = true;
      },
      doApprove() {
        let billParam = [];
        for (let item of this.businessApplicationVO.applicationPriceWrapperS) {
          item.optionalPriceVOS.forEach((item) => {
            let obj = {
              approve1Price: item.approve1Price,
              approve2Price: item.approve2Price,
              approve3Price: item.approve3Price,
              costPrice: item.costPrice,
              padetailID: item.pkid,
              priceApplicationType: 40,
            };
            if (item.isChange) {
              billParam.push(obj);
            }
          });
          for (let item1 of item.paDetailVOS) {
            let object = {};
            if (this.businessApplicationVO.approveStatus === 10) {
              object.costPrice = item1.costPrice;
              object.costFloatingPrice = item1.costFloatingPrice;
            } else if (this.businessApplicationVO.approveStatus === 1) {
              object.approve1Price = item1.approve1Price;
              object.approve1FloatingPrice = item1.approve1FloatingPrice;
            } else if (this.businessApplicationVO.approveStatus === 2) {
              object.approve2Price = item1.approve2Price;
              object.approve2FloatingPrice = item1.approve2FloatingPrice;
            } else if (this.businessApplicationVO.approveStatus === 20) {
              object.finApprovePrice = item1.finApprovePrice;
              object.finApproveFloatingPrice = item1.finApproveFloatingPrice;
            } else {
              object.approve3Price = item1.approve3Price;
              object.approve3FloatingPrice = item1.approve3FloatingPrice;
            }
            object.padetailID = item1.padetailID;
            if (item1.isChange) {
              billParam.push(object);
            }}
        }
        console.log(this.businessApplicationVO.applicationPriceWrapperS);
        console.log(billParam);
        let params = {
          billId: parseInt(this.billId),
          billType: parseInt(this.billType),
          sequId: parseInt(this.sequId),
          actionType: this.params.actionType,
          approveNote: this.params.approveNote,
          untreadedFlowId: this.params.untreadedFlowId,
          billParam: JSON.stringify(billParam),
        };
        this.$emit("loading-status", { loading: true });
        this.$http
          .post("basic", "applications/doApprove", params)
          .then(() => {
            this.$emit("loading-status", { loading: false });
            this.$message.success("保存成功");
            // 关闭标签
            this.$bus.$emit("closeTag", this.$route);
            this.$router.push({
              path: "/workFlow/BusinessApplication",
            });
          })
          .catch(() => {
            this.$emit("loading-status", { loading: false });
          });
      },
      changeOptionalPriceVOS() {
        this.isShow = !this.isShow;
      },
      getNodeValue() {
        let params = {
          "billType": this.billType,
          "billId": this.billId,
          "sequId": this.sequId,
        };
        this.$http
          .get("basic", "applications/approve", params)
          .then(resp => {
            this.nodeId = resp.nodeId;
            console.log(resp);
          });
      },
      changeIsHidden() {
        this.loading = true;
        this.$nextTick(() => {
          for (let item of this.businessApplicationVO.allApplicationPriceWrapperS) {
            this.$refs.multipleTable.toggleRowExpansion(item, this.isHidden);
          }
          this.loading = false;
        });
        this.isHidden = !this.isHidden;
      },
    },
  };
</script>

<style lang="scss">
.businessApplicationDetails {
  width: 100%;
  margin: 10px auto;
  .businessApplicationDetails-word {
    width: 98%;
    padding: 10px 1%;
    font-size: 14px;
    background: #f4f7fa;
    border-bottom: 1px solid #dddddd;
  }

  .businessApplicationDetails-first {
    border: 1px solid #dddddd;
    .businessApplicationDetail-message {
      padding: 10px;
      table.businessApplicationTable {
        font-family: verdana, arial, sans-serif;
        font-size: 11px;
        color: #333333;
        border-width: 1px;
        border-color: #dddddd;
        border-collapse: collapse;
      }
      table.businessApplicationTable th {
        text-align: left;
        border-width: 1px;
        padding: 8px;
        border-style: solid;
        border-color: #dddddd;
        background-color: #d1e6f5;
      }
      table.businessApplicationTable td {
        border-width: 1px;
        padding: 8px;
        border-style: solid;
        border-color: #dddddd;
      }
      .tableLabel {
        width: 10%;
        text-align: right;
        background-color: #d1e6f5;
      }
    }
  }
  .businessApplicationDetails-seond {
    position: relative;
    margin-top: 1%;
    border: 1px solid #dddddd;
    .table-pj {
      width: 100%;
      background: #ffffff;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 100;
      margin-top: 35px !important;
      border-top: 1px solid #ebebeb;
      tr {
        td:first-child {
          border-left: none;
        }
        td {
          border-left: 1px solid #ebebeb;
          font-size: 12px;
          text-align: center;
          padding: 5px 0;
          div {
            width: 40%;
            margin: 0 auto 5px auto;
            text-align: left;
          }
          div:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    .businessApplicationDetails-seond-bottom {
      .historyBtn {
        button {
          border: none;
          background: #f4f7fa;
          padding: 0;
          margin: 0;
          i {
            color: #2d8cf0;
          }
        }
      }
    }
  }

  .el-table th {
    background: #d1e6f5;
    height: 34px;
  }
  .el-input--mini .el-input__inner {
    padding: 0;
    text-align: center;
  }

  .el-table th.is-leaf,
  .el-table td {
    padding: 5px 0;
  }
  .el-table__header,
  .el-table__body,
  .el-table__footer {
    width: 100% !important;
  }
  @media (max-width: 1003px) {
    .jg-el-table {
      margin-top: 135px !important;
    }
  }
  @media (min-width: 1004px) and (max-width: 1116px) {
    .jg-el-table {
      margin-top: 120px !important;
    }
  }
  @media (min-width: 1117px) and (max-width: 1231px) {
    .jg-el-table {
      margin-top: 108px !important;
    }
  }
  @media (min-width: 1300px) and (max-width: 1440px) {
    .businessApplicationDetail {
      width: 1440px;
    }
  }
}
</style>
